<form [formGroup]="searchForm" data-testid="ultimate-parent-search-modal">
  <h3 nxHeadline class="nx-font-weight-semibold" size="s">
    {{ data.titleI18n | translate }}
  </h3>
  <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
    <nx-formfield [label]="'ultimate-parent-search.ehid.label' | translate" appearance="outline" floatLabel="always">
      <input
        nxInput
        required
        [placeholder]="'ultimate-parent-search.ehid.placeholder' | translate"
        name="ultimateParentEhid"
        formControlName="ultimateParentEhid"
        type="text"
      />
      <button [disabled]="searchForm.invalid" nxFormfieldAppendix nxButton="small-medium" type="submit">
        {{ 'ultimate-parent-search.search' | translate }}
      </button>
    </nx-formfield>
  </form>
  @if (isSearchLoading) {
    <div class="flex justify-center"><nx-spinner class="mt-2.5" size="large" /></div>
  } @else if (hasSearchError) {
    <div class="my-2.5 mx-16">
      <nx-error nxFormfieldError>
        <strong>{{ 'ultimate-parent-search.search-error' | translate }}</strong>
      </nx-error>
    </div>
  } @else if (searchResult) {
    <kyc-company-search-results
      class="centered"
      [results]="[searchResult]"
      [buttonsData]="resultButtons"
      [isLoading]="isPerformingAction"
    />
  }
  <div class="flex justify-center mt-3.5">
    <button nxModalClose nxButton="tertiary small-medium" type="button" [disabled]="isPerformingAction">
      {{ 'ultimate-parent-search.dismiss' | translate }}
    </button>
  </div>
</form>
